import { useState } from "react";
import clsx from "clsx";

export type AvatarTableProps = {
  textImage?: string;
  image: string | undefined;
  fallbackSrc?: string;
  className?: string;
};

const AvatarTable: React.FC<AvatarTableProps> = ({
  textImage = "image",
  image,
  fallbackSrc,
  className = "h-11 w-11",
}) => {
  const [imageSrc, setImageSrc] = useState(
    image ||
      fallbackSrc ||
      "https://test.fitmewise.com/uploads/branchs/default.png"
  );
  const handleError = () => {
    setImageSrc(
      fallbackSrc ?? "https://test.fitmewise.com/uploads/branchs/default.png"
    );
  };
  return (
    <div className={clsx("flex-shrink-0", className)}>
      <img
        alt={textImage}
        src={imageSrc}
        className={clsx("rounded", className)}
        onError={handleError}
      />
    </div>
  );
};

export default AvatarTable;
